import { axios } from "@/axios"

export async function clearEventTemplate(templateId?: number, eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to un-apply template. Please ensure `eventVaultId` is provided.",
    )
  }

  if (!templateId) {
    throw new Error(
      "Missing `templateId` when attempting to un-apply template. Please ensure `templateId` is provided.",
    )
  }

  const response = await axios.post(`api/template/${templateId}/clear?eventVaultId=${eventVaultId}`)

  return response.data?.Message
}
